// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1_QKT","colMin":"styles_colMin__17ebD","colCheckbox":"styles_colCheckbox__30uHM"};